import React from "react";
import { graphql } from "gatsby";
import SummaryDisplay from "./SummaryDisplay";
import {
  StringValue,
  KontentMultiChoice,
  KontentSummary,
} from "../../../types";
import { getMultiChoice } from "../../../lib/multichoice";
import { formatSummaries } from "../../../lib/summaryDisplay";

export type tileLayouts =
  | "full_width"
  | "onethird_twothird"
  | "twothird_onethird"
  | "thirds"
  | "collage"
  | "quarters";

export interface SummaryDisplayProps {
  style: KontentMultiChoice<tileLayouts>;
  show_equals_sign: KontentMultiChoice<"yes" | "no">;
  display_images: KontentMultiChoice<"yes" | "no">;
  summaries: {
    modular_content: KontentSummary[];
  };
  component_settings__anchor_name: StringValue;
  component_settings__hide_on_mobile: KontentMultiChoice<"yes" | "no">;
  component_layout__component_width: KontentMultiChoice<"full" | "contained">;
  id: string;
  summary_alignment: KontentMultiChoice<"by_title" | "by_text">;
}

const SummaryDisplayContainer: React.FC<SummaryDisplayProps> = ({
  style,
  summaries,
  show_equals_sign,
  display_images,
  component_layout__component_width,
  component_settings__anchor_name,
  component_settings__hide_on_mobile,
  summary_alignment,
  id,
}) => {
  const tileLayout = getMultiChoice(style);

  if (!summaries?.modular_content) return null;

  const summaryDisplay = formatSummaries(summaries.modular_content);
  const componentWidth = getMultiChoice(component_layout__component_width);
  const displayImages = getMultiChoice(display_images);
  const summaryAlignment = getMultiChoice(summary_alignment);
  if (!summaryDisplay) return null;

  return (
    <SummaryDisplay
      tileLayout={tileLayout}
      summaries={summaryDisplay}
      width={componentWidth}
      anchor={component_settings__anchor_name.value}
      showEquals={getMultiChoice(show_equals_sign) === "yes"}
      displayImages={displayImages === "yes" || displayImages === null}
      hideOnMobile={
        getMultiChoice(component_settings__hide_on_mobile) === "yes"
      }
      summaryAlignment={summaryAlignment}
      id={id}
    />
  );
};

export default SummaryDisplayContainer;

// Verify kontent_item_component___ name

export const fragmentSummaryDisplay = graphql`
  fragment SummaryDisplay on kontent_item_summary_display {
    system {
      id
      codename
    }
    internal {
      type
      contentDigest
    }
    elements {
      component_layout__component_width {
        value {
          codename
        }
      }
      component_settings__anchor_name {
        value
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
      show_equals_sign {
        value {
          codename
        }
      }
      display_images {
        value {
          codename
        }
      }
      summary_alignment {
        value {
          codename
        }
      }
      style {
        value {
          codename
        }
      }
      summaries {
        modular_content {
          ...kontentSummary
        }
      }
    }
  }
`;
